import { useSystemStore } from "components/PageHeader/systemStore";
import { useTabsStore } from "components/Tabs/tabsStore";
import { useIsDesktop } from "lib/device";
import { useJPTrackers } from "modules/Tenant/homeTenantApi";
import { useLearningHourStore } from "modules/Tenant/learningHourStore";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function JpChip() {
  const userLearningHour = useJPTrackers();
  const { learningHour, setLearningHour } = useLearningHourStore();
  const [jpInfo, setJpInfo] = useState(false);
  const { setSelectedTab } = useTabsStore();
  const [theme] = useSystemStore((state) => [state.theme]);
  const isDesktop = useIsDesktop();
  const router = useRouter();

  useEffect(() => {
    userLearningHour.doFetch(
      {},
      {
        onSuccess(data: any) {
          setLearningHour(data?.data?.learning_hours);
        },
        onError(err) {
          const error: any = err.getActualType();
          console.log(error);
        },
      }
    );
  }, []);

  return (
    <div className="relative">
      <div
        onMouseEnter={isDesktop ? () => setJpInfo(true) : () => {}}
        onMouseLeave={isDesktop ? () => setJpInfo(false) : () => {}}
        className="cursor-pointer px-[14px] py-[8px] rounded-100 flex gap-8 items-center justify-center text-b1 text-purple60_to_dark10 bg-light_neutral10_to_dark_neutral50"
        onClick={() => {
          setSelectedTab({
            id: "kursus-selesai",
            label: "Kursus Selesai",
            title: "Kursus yang Kamu Ambil",
            value: "finished",
          });

          router.replace({
            pathname: "/my-class",
            query: {
              tabId: "kursus-selesai",
            },
          });
        }}
      >
        {theme === "dark" ? (
          <Image
            src={"/images/jp-dark.svg"}
            alt="leaderboard"
            width={18}
            height={18}
          />
        ) : (
          <Image
            src={"/images/jp.svg"}
            alt="leaderboard"
            width={18}
            height={18}
          />
        )}
        <span
          className={`${
            theme === "dark" ? "text-[#fff]" : "text-[#5D586C]"
          } font-[500] text-[14px]`}
        >
          {learningHour} JP
        </span>
      </div>

      {jpInfo && (
        <span className="absolute rounded-md p-4 min-w-[200px] flex justify-center items-center z-10 top-54 right-0 cursor-pointer bg-[#A39DB0] text-white font-light">
          Progress Belajar : {learningHour} JP
        </span>
      )}
    </div>
  );
}
